const CACHE_TTL_MS = 5 * 60 * 1000;

const cache = new Map();

const getCacheKey = (country = "", id = "") =>
  JSON.stringify({ country: country || "", id: id || "" });

export const normalizeAdminUsers = (data) => {
  if (Array.isArray(data)) {
    return data;
  }
  if (data && data._id) {
    return [data];
  }
  return [];
};

export const getCachedAdminUserList = (country = "", id = "") => {
  const entry = cache.get(getCacheKey(country, id));
  if (!entry) {
    return null;
  }

  if (Date.now() - entry.timestamp > CACHE_TTL_MS) {
    cache.delete(getCacheKey(country, id));
    return null;
  }

  return entry;
};

export const setCachedAdminUserList = (country, id, users) => {
  cache.set(getCacheKey(country, id), {
    users,
    timestamp: Date.now(),
  });
};

export const invalidateAdminUserListCache = () => {
  cache.clear();
};

export const getAdminUserListCacheAge = (country = "", id = "") => {
  const entry = cache.get(getCacheKey(country, id));
  if (!entry) {
    return null;
  }
  return Date.now() - entry.timestamp;
};
